/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
// eslint-disable-next-line no-unused-vars
import slickcss from 'slick-carousel/slick/slick.css';
import WithElectionBannerLoadable from 'components/ElectionBanner/WithElectionBannerLoadable';
import { getBannerData, debounce } from 'utils/common';
import { getPosition } from 'utils/DOMUtils';
import ImageV2 from 'components_v2/common/ImageV2';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import s from './LeadImageOrVideo.scss';
import ArticleLeadCaption from '../ArticleLeadCaption/ArticleLeadCaption';

class LeadImageOrVideo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      videoActive: false,
      isClientSide: false,
      leadVideoIsDocked: false,
    };
    this.myRef = React.createRef();
    this.debounceHandleImageView = debounce(
      this.handleImageView.bind(this),
      10,
    );
    this.oldFlag = false;
  }
  handleImageView() {
    const pos =
      window.innerHeight -
      (getPosition(this.myRef.current).y - window.pageYOffset);
    let flag = false;
    if (pos >= this.props.bottom) {
      flag = true;
    } else {
      flag = false;
    }
    if (this.oldFlag !== flag && typeof this.props.cb === 'function') {
      this.props.cb(flag);
      this.oldFlag = flag;
    }
  }
  componentDidMount() {
    const { video, loadVideoTheatreSlider } = this.props;
    if (loadVideoTheatreSlider && video.id) {
      this.props.loadVideoTheatreSlider(video.wu, this.props.isWapView);
    }
    if (typeof window !== 'undefined') {
      this.setState({
        isClientSide: true,
      });
    }
    window.addEventListener('scroll', this.debounceHandleImageView);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.debounceHandleImageView);
  }

  onVideoComnponentLoadOrUnload = (status = false) => {
    //alert('onVideoComnponentLoadOrUnload' + status);
    this.setState({
      videoActive: status,
    });
  };

  videoPlayCallback = status => {
    this.onVideoComnponentLoadOrUnload(status);
  };

  leadVideoIsDockedCallback = status => {
    this.setState({ leadVideoIsDocked: status });
  };

  render() {
    const ss = this.props.styleObj;
    const {
      image,
      videoCaption,
      widgets,
      imgList,
      imageAlt,
      preloadedLeadImageHref,
      syn,
      isMspArticle,
      hl,
      isSPOTLIGHTArticle,
      isAutoPublishedArticle,
    } = this.props;
    const wdtData =
      widgets && widgets instanceof Array && widgets.length > 0
        ? getBannerData(widgets)
        : undefined;

    let resizemode = isAutoPublishedArticle && !isSPOTLIGHTArticle ? 72 : 4;

    let leadImageWidth = `width-800`;
    let height =
      isAutoPublishedArticle && !isSPOTLIGHTArticle ? 'height-450,' : '';

    let sliderImgWidth = `width-838`;

    if (this.props.isPrimeContent) {
      leadImageWidth = `width-1000`;
      height =
        isSPOTLIGHTArticle && !isAutoPublishedArticle ? `` : `height-562,`;

      sliderImgWidth = `width-1000`;

      resizemode = !isAutoPublishedArticle && isSPOTLIGHTArticle ? 4 : 75;
    }

    const settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: true,
      arrows: false,
      swipeToSlide: true,
      autoplay: true,
      draggable: false,
      infinite: true,
      dotsClass: s.dots,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    };

    const playerContainerId = `playerContainer_${this.props.video.id}`;
    const getComponentData = (
      <div className={s.dockWrap}>
        {this.props.video.id && (
          <div className={s.mainImg}>
            <ImageV2
              src={`https://static.toiimg.com/thumb/msid-${this.props.video
                .id ||
                this.props
                  .videoImageId},${leadImageWidth},${height}resizemode-${resizemode}/${this
                .props.video.id || this.props.videoImageId}.jpg`}
              altTitle={this.props.video.hl ? this.props.video.hl : ''}
              title={this.props.video.hl ? this.props.video.hl : ''}
              className={`${s.leadVideoBg}`}
            />
          </div>
        )}
        <section
          className={`${s.leadmedia}  clearfix id-r-component leadmedia ${
            this.props.sClassName
          } ${s[this.props.className]} ${
            this.state.videoActive &&
            !this.props.isWapView &&
            !this.props.frmNic
              ? 'vdoactive'
              : ''
          } ${!this.props.video.id ? s.unDock : ''}  ${
            this.props.isPrimeContent ? '' : s.nonprimeImageWidth
          }   `}
          ref={this.myRef}
          style={!this.state.leadVideoIsDocked ? { top: '0px' } : {}}
        >
          {Array.isArray(imgList) &&
            imgList.length > 0 && (
              <div className={`${s.stateContainer} as_alider `}>
                <Slider
                  ref={slider => {
                    this.slider = slider;
                  }}
                  {...settings}
                >
                  {imgList.filter((v, i) => i < 6).map(item => (
                    <>
                      <div
                        className={`resp_container ${
                          !item.cap && (!item.name || item.name === '#')
                            ? 'no_Caption'
                            : ''
                        }`}
                      >
                        <div className="img_wrapper">
                          {item.id &&
                            (item.id === '93166496' ||
                              item.id === '101017261') && (
                              <img
                                src={`https://static.toiimg.com/thumb/msid-${
                                  item.id
                                }${
                                  item.imagesize
                                    ? `,imgsize-${item.imagesize}`
                                    : ''
                                },${sliderImgWidth},resizemode-${resizemode}/${
                                  item.id
                                }.jpg`}
                                alt={hl}
                                title={
                                  item.cap ||
                                  (item.name && item.name !== '#'
                                    ? item.name
                                    : '')
                                }
                                decoding="async"
                              />
                            )}
                          {item.id &&
                            item.id !== '93166496' &&
                            item.id !== '101017261' && (
                              <img
                                src={`https://static.toiimg.com/thumb/msid-${
                                  item.id
                                }${
                                  item.imagesize
                                    ? `,imgsize-${item.imagesize}`
                                    : ''
                                },${leadImageWidth},${height}resizemode-${resizemode}/${
                                  item.id
                                }.jpg`}
                                alt={hl}
                                title={
                                  item.cap ||
                                  (item.name && item.name !== '#'
                                    ? item.name
                                    : '')
                                }
                                decoding="async"
                              />
                            )}
                        </div>
                      </div>
                      {item.cap ||
                        (item.name &&
                          item.name !== '#' && (
                            <ArticleLeadCaption
                              imgCaption={
                                isMspArticle ? syn : item.cap || item.name
                              }
                              styleObj={{ ...s, ...ss }}
                              isWapView={this.props.isWapView}
                              isMspArticle={isMspArticle}
                              isPrimeContent={this.props.isPrimeContent}
                            />
                          ))}
                    </>
                  ))}
                </Slider>
              </div>
            )}
          {!imgList &&
            this.props.image &&
            this.props.image.id && (
              <div className={s.leadmedia}>
                <div className={s.img_wrapper}>
                  <div className={s.content}>
                    {this.props.isExplainerArticle && (
                      <i
                        className={`${s.explainerstamp} ${this.props
                          .isWapView && s.small}`}
                      />
                    )}
                    {isSPOTLIGHTArticle && (
                      <img
                        src={
                          preloadedLeadImageHref ||
                          `https://static.toiimg.com/thumb/msid-${
                            this.props.image.id
                          }${
                            this.props.image.imagesize
                              ? `,imgsize-${this.props.image.imagesize}`
                              : ''
                          },${sliderImgWidth},resizemode-${resizemode}/${
                            this.props.image.id
                          }.jpg`
                        }
                        alt={hl || imageAlt || 'banner img'}
                        title={
                          image.cap ||
                          (image.name && image.name !== '#' ? image.name : '')
                        }
                        decoding="async"
                        // eslint-disable-next-line react/no-unknown-property
                        fetchpriority="high"
                      />
                    )}
                    {!isSPOTLIGHTArticle && (
                      <img
                        src={
                          preloadedLeadImageHref ||
                          `https://static.toiimg.com/thumb/msid-${
                            this.props.image.id
                          }${
                            this.props.image.imagesize
                              ? `,imgsize-${this.props.image.imagesize}`
                              : ''
                          },${leadImageWidth},${height}resizemode-${resizemode}/${
                            this.props.image.id
                          }.jpg`
                        }
                        alt={hl || imageAlt || 'banner img'}
                        title={
                          image.cap ||
                          (image.name && image.name !== '#' ? image.name : '')
                        }
                        decoding="async"
                        // eslint-disable-next-line react/no-unknown-property
                        fetchpriority="high"
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          {!imgList &&
            this.props.video &&
            this.props.video.id && (
              //this.props.isWapView && (
              <>
                <LoadableComponentLoader
                  loadInView
                  loadableComponentName="VideoWidget"
                  activeMsid={this.props.activeMsid}
                  artilceMsid={this.props.artilceMsid}
                  autoPlay={
                    !!(
                      (!this.props.isWapView || this.props.enableAutoPlay) &&
                      //!this.props.loadedMiniTvComponent &&
                      !this.props.isPerpetual
                    )
                  }
                  isMute={
                    !!(!this.props.isWapView || this.props.enableAutoPlay) //&&
                    // !this.props.loadedMiniTvComponent
                  }
                  //videoActive={!this.props.isWapView}
                  video={this.props.video}
                  isLeadVideo
                  notitle
                  styleObj={s}
                  isUserPrime={this.props.isUserPrime}
                  iconClassName={s.playicon}
                  imageClassName={`${s.content}`}
                  videoClassName={`${s.content}`}
                  theatreModeClassName={s.leadvid_theatre_open}
                  isWapView={this.props.isWapView}
                  videoImageId={this.props.videoImageId}
                  videoPlayCallback={this.videoPlayCallback}
                  playerContainerId={playerContainerId}
                  videoTheatreSliderData={this.props.videoTheatreSliderData}
                  addNextVideoMsid={this.props.addNextVideoMsid}
                  dataFirstPlayClickGa={`ATF_lead_video|video-lead-user_initiated|msid_${
                    this.props.artilceMsid
                  }-video_${
                    this.props.video && this.props.video.id
                      ? this.props.video.id
                      : ''
                  }`}
                  dataSetGaCategory
                  dataCloseClickGa={`video-lead-close_video|msid_${
                    this.props.artilceMsid
                  }-video_${
                    this.props.video && this.props.video.id
                      ? this.props.video.id
                      : ''
                  }`}
                  isArticleshow={this.props.isArticleshow}
                  showMiniTvPlayer={this.props.showMiniTvPlayer}
                  enableDocking={this.props.enableDocking}
                  enableAutoPlay={this.props.enableAutoPlay}
                  leadVideoIsDockedCallback={this.leadVideoIsDockedCallback}
                />
              </>
            )}
          {!imgList && (
            <ArticleLeadCaption
              imgCaption={
                isMspArticle
                  ? syn
                  : image.cap ||
                    (image.name && image.name !== '#' ? image.name : '')
              }
              styleObj={{ ...s, ...ss }}
              videoCaption={videoCaption}
              isWapView={this.props.isWapView}
              isMspArticle={isMspArticle}
              isPrimeContent={this.props.isPrimeContent}
            />
          )}

          {!this.props.isWapView &&
            this.state.isClientSide &&
            wdtData && (
              <WithElectionBannerLoadable
                wdtData={wdtData}
                wrapperClassName="elec_banner"
              />
            )}
        </section>
      </div>
    );

    return (
      <>
        {this.props.isWapView && (
          <>
            <div id={`leadSentinal_${this.props.video.id}`} />
            <div
              className={`
                ${ss.leadWrapper} 
                ${this.props.isEtimesArticle ? ss.etimesLeadWrapper : ''} 
                ${this.state.leadVideoIsDocked ? 'docklead' : ''}
              `}
            >
              {getComponentData}
            </div>
          </>
        )}
        {!this.props.isWapView && <> {getComponentData} </>}
      </>
    );
  }
}

LeadImageOrVideo.propTypes = {
  image: PropTypes.shape({
    imagesize: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    cap: PropTypes.string,
  }),
  imageAlt: PropTypes.string,
  video: PropTypes.shape({
    id: PropTypes.string.isRequired,
    h1: PropTypes.string.isRequired,
    playerId: PropTypes.string.isRequired,
    imageid: PropTypes.string.isRequired,
    payload: PropTypes.string.isRequired,
    //iconClassName: PropTypes.string.isRequired,
    //imageClassName: PropTypes.string.isRequired,
    //videoClassName: PropTypes.string.isRequired,
  }),
  //highlight: PropTypes.arrayOf(PropTypes.string),
  //highlightCdata: PropTypes.arrayOf(PropTypes.string),
  sClassName: PropTypes.string.isRequired,
  styleObj: PropTypes.shape({}).isRequired,
  videoCaption: PropTypes.string,
  isWapView: PropTypes.bool,
  videoImageId: PropTypes.string.isRequired,
  loadVideoTheatreSlider: PropTypes.func,
  frmNic: PropTypes.bool,
  isUserPrime: PropTypes.bool,
  videoTheatreSliderData: PropTypes.arrayOf({}),
  addNextVideoMsid: PropTypes.func.isRequired,
  artilceMsid: PropTypes.string,
  isArticleshow: PropTypes.bool,
  widgets: PropTypes.shape({}),
  cb: PropTypes.func.isRequired,
  bottom: PropTypes.number,
  isExplainerArticle: PropTypes.bool,
  preloadedLeadImageHref: PropTypes.string,
  syn: PropTypes.string,
  isMspArticle: PropTypes.bool,
  isEtimesArticle: PropTypes.bool,
  showMiniTvPlayer: PropTypes.func,
  isSPOTLIGHTArticle: PropTypes.bool,
  //loadedMiniTvComponent: PropTypes.bool,
};

LeadImageOrVideo.defaultProps = {
  image: {},
  imageAlt: undefined,
  video: {},
  //highlight: [],
  //highlightCdata: [],
  videoCaption: '',
  isWapView: false,
  loadVideoTheatreSlider: undefined,
  frmNic: false,
  isUserPrime: false,
  videoTheatreSliderData: undefined,
  artilceMsid: '',
  isArticleshow: false,
  widgets: undefined,
  bottom: undefined,
  isExplainerArticle: false,
  preloadedLeadImageHref: '',
  syn: '',
  isMspArticle: false,
  isSPOTLIGHTArticle: false,
  isEtimesArticle: false,
  //styleObj: {},
  showMiniTvPlayer: undefined,
  //loadedMiniTvComponent: false,
};

export default LeadImageOrVideo;
